import { Objection } from '../../objection/objection';

export function getObjectionPrompt(objectionList: Objection[], question: string) {

  // extract fields of title, description, id from object in objectionList, convert them into a comma separated string list
  const extractedObjectionList = objectionList.map((objection) => {
    return `Title: ${objection.title},Description: ${objection.description},ObjectId ${objection.id}`;
  });
  const objectionListString = extractedObjectionList.join('\n');

  return `
Given a question as input below as <QUESTION>, find the most relevant objection from the following list of objections as <OBJECTIONS> and return the title, description, and id of the objection.

<QUESTION>
${question}
</QUESTION>

<OBJECTIONS>
${objectionListString}
</OBJECTIONS>
  `;
}

export function getObjectionFunctions(objectionList: Objection[], question: string) {
  // extract fields of title, description, id from object in objectionList, convert them into a comma separated string list
  const extractedObjectionList = objectionList.map((objection) => {
    return `Title: ${objection.title},Description: ${objection.description},ObjectId ${objection.id}`;
  });
  const objectionListString = extractedObjectionList.join('\n');

  return [
    {
      name: 'get_most_relevant_objection_from_question',
      description:
        `
Given a question as input below as <QUESTION>, find the most relevant objection from the following list of objections as <OBJECTIONS> and return the title, description, and id of the objection.

<QUESTION>
${question}
</QUESTION>
  `,
      parameters: {
        type: 'object',
        properties: {
          objectionId: {
            type: 'string',
            description: 'the ObjectID of the most relevant objection from the following list of objections as <OBJECTIONS>',
          }
        },
      },
    },
  ];
}
